import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "src/layouts/HomeLayout/TopBar";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#F8FAFB",
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
    transition: "background-color 0.3s ease",
  },

  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#fff",
    paddingTop: 96,
    minHeight: "calc(100vh - 75px)",
    transition: "padding 0.3s ease",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 300,
    },
    "@media (max-width:767px)": {
      paddingTop: "70px !important",
    },
  },

  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "auto",
    background: "#FAFAFA",
    transition: "background-color 0.3s ease",
  },

  dashboardContent: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
    overflowX: "auto",
    position: "relative",
    transition: "padding 0.3s ease",
    [theme.breakpoints.down("md")]: {
      padding: "25px 10px 10px ",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px 10px 10px ",
    },
  },

  content: {
    flex: "1 1 auto",
    minHeight: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    position: "relative",
    padding: "28px 25px 25px ",
    transition: "padding 0.3s ease",
    [theme.breakpoints.down("md")]: {
      padding: "30px 10px 10px ",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "45px 10px 10px ",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  const dashboardRoute = window.location.pathname === "/dashboard";

  return (
    <div className={classes.root}>
      <TopBar fixed onMobileNavOpen={()=>setMobileNavOpen(true)}/>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div
            className={
              dashboardRoute ? classes.dashboardContent : classes.content
            }
            id="main-scroll"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
